export const GET_ALL_ADMIN = 'GET_ALL_ADMIN';
export const GET_ALL_ADMIN_SUCCESS = 'GET_ALL_ADMIN_SUCCESS';
export const GET_ALL_ADMIN_ERROR = 'GET_ALL_ADMIN_ERROR';
export const CREATE_ADMIN = 'CREATE_ADMIN';
export const CREATE_ADMIN_SUCCESS = 'CREATE_ADMIN_SUCCESS';
export const CREATE_ADMIN_ERROR = 'CREATE_ADMIN_ERROR';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_ERROR = 'UPDATE_ADMIN_ERROR';
export const DELETE_ADMIN = 'DELETE_ADMIN';
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS';
export const DELETE_ADMIN_ERROR = 'DELETE_ADMIN_ERROR';

export const GET_ALL_PAGINATION_ADMIN = 'GET_ALL_PAGINATION_ADMIN';
export const GET_ALL_PAGINATION_ADMIN_SUCCESS =
  'GET_ALL_PAGINATION_ADMIN_SUCCESS';
export const GET_ALL_PAGINATION_ADMIN_ERROR = 'GET_ALL_PAGINATION_ADMIN_ERROR';

// current_admin
export const GET_CURRENT_ADMIN = 'get_current_admin';
export const GET_CURRENT_ADMIN_SUCCESSFUL = 'get_current_admin_successfull';
export const GET_CURRENT_ADMIN_FAILED = 'get_current_admin_failed';

export const UPDATE_CURRENT_ADMIN_DATA = 'update_current_admin_data';

// change_admin_password
export const CHANGE_ADMIN_PASSWORD = 'change_admin_password';
export const CHANGE_ADMIN_PASSWORD_SUCCESSFUL =
  'change_admin_password_successfull';
export const CHANGE_ADMIN_PASSWORD_FAILED = 'change_admin_password_failed';

// update_user_data
export const UPDATE_CURRENT_ADMIN = "update_user_data";
export const UPDATE_CURRENT_ADMIN_SUCCESSFUL = "update_user_data_successfull";
export const UPDATE_CURRENT_ADMIN_FAILED = "update_user_data_failed";